"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'WriteOff',
  props: {
    iShidden: {
      type: Boolean,
      default: true
    },
    orderInfo: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {};
  },
  // created() - media_750 import removed for PC compatibility
  methods: {
    toDetail: function toDetail(item) {
      this.$router.push({
        path: '/javaMobile/orderDetail/' + item.orderId + '/looks'
      });
    },
    cancel: function cancel() {
      this.$emit('cancel', true);
    },
    confirm: function confirm() {
      this.$emit('confirm', true);
    }
  }
};